module.exports = __webpack_public_path__ + "img/arrow-left.4b213058.svg";